import { LightbulbMultipleOutlineIcon } from './LightbulbMultipleOutlineIcon';

/**
 * author: Michael Richins
 * id 7AAEC297-D587-4D13-9397-50C8C93B48C8
 * name lightbulb-multiple-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-multiple-outline.svg
 * tags
 * - Home Automation 
 */
export const LightbulbsOutlineIcon = LightbulbMultipleOutlineIcon;
export default LightbulbsOutlineIcon